export function parseSpn(spn?: string | null): string | null {
    if (spn !== null && spn !== undefined && spn.trim() !== '') {
        return spn;
    }
    return null;
}
